import React from 'react';
import graph from '../graph';
import Update from '../Update';
import LoginAs from '../LoginAs';
import UserRoles from '../UserRoles';
import UserGroups from '../UserGroups';

import {
  Fade,
  Card,
  Stack,
  Checkbox,
  Typography,
  CardHeader,
  CardContent,
  CardActions,
  CardActionArea,
  Chip,
  Button,
} from '@mui/material';

import { AvatarPopover, CustomList, NewMediaPopup } from 'components';
import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';
import { CallRounded } from '@mui/icons-material';
import { addCommas } from '@persian-tools/persian-tools';

export default function Model({ filter, model, delay, checked, refetch, isAssign, selectable, handleSelect }) {
  const {
    id,
    media,
    firstname,
    lastname,
    cellphone,
    categories,
    all_roles,
    device_token,
    used_amount_of_selected_coupon,
  } = model;

  const { roles } = useSelector((state) => state.auth.userInfo);
  const isAdmin = hasRequiredRole(['superadmin'], roles);

  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}>
        <Stack direction="row" alignItems="center">
          <Card
            sx={{
              width: '100%',
              position: 'relative',
              borderColor: checked && 'primary.main',
              bgcolor: checked && 'action.disabledBackground',
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              avatar={
                <NewMediaPopup
                  id={id}
                  model="User"
                  collection="avatar"
                  title={`${firstname} ${lastname}`}
                  graph={graph}
                >
                  <AvatarPopover isAssign={isAssign} sx={{ width: 48, height: 48 }} media={media[0]?.full_url} />
                </NewMediaPopup>
              }
              title={`${firstname} ${lastname}`}
              action={
                <Button size="small" color="success" variant="outlined" endIcon={<CallRounded />}>
                  {cellphone}
                </Button>
              }
            />
            {filter?.used_this_coupon === 'HAVE' && (
              <CardContent style={{paddingBottom: 0, padding: 4}}>
                <CustomList
                  data={{
                    title: 'مقدار استفاده از بن',
                    value: addCommas(Number(used_amount_of_selected_coupon)),
                    unit: 'تومان',
                  }}
                />
                {/* <Typography variant="caption">{`مقدار استفاده از بن: ${addCommas(
                  Number(used_amount_of_selected_coupon)
                )} تومان`}</Typography> */}
              </CardContent>
            )}
            {isAdmin && (
              <CardActions sx={{ justifyContent: 'flex-end' }}>
                <UserRoles ids={id} refetch={refetch} roles={all_roles || []} title="userRoles" />
                <UserGroups ids={id} refetch={refetch} groups={categories} title="userGroups" />
                <Update ids={id} title="update" refetch={refetch} />
              </CardActions>
            )}
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: 'absolute',
              }}
              disabled={!isAssign && !selectable}
              onClick={handleSelect}
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
